<template>
  <div class="view-wrapper d-flex flex-column" style="height: 88vh; overflow: hidden;">
    
    <v-card class="elevation-1 rounded-0 mb-1 flex-shrink-0" color="grey lighten-5">
      <v-card-text class="pa-2">
        <div class="d-flex justify-space-between align-center">
          <div>
            <span class="font-weight-bold text-subtitle-1 black--text">{{ nomeCliente }}</span>
            <div class="caption grey--text text--darken-2">
              Cód: {{ codigoCliente }}
            </div>
          </div>
          <!-- <div class="text-right">
            <div class="caption">Saldo Restante</div>
            <div class="font-weight-bold" :class="saldoCredito >= 0 ? 'green--text' : 'red--text'">
                {{ formatarMoeda(saldoCredito) }}
            </div>
          </div> -->
        </div>
        <v-divider class="my-2"></v-divider>
        <div class="d-flex justify-space-between caption">
          <span>Total Aberto: <b>{{ formatarMoeda(totalDivida) }}</b></span>
          <span>Títulos: <b>{{ titulos.length }}</b></span>
        </div>
      </v-card-text>
    </v-card>

    <div class="content-container flex-grow-1 elevation-1 white" style="position: relative; overflow: hidden;">
      
      <div v-if="loading" class="d-flex justify-center align-center fill-height">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div v-else-if="titulos.length === 0" class="d-flex justify-center align-center fill-height grey--text">
        <div class="text-center">
          <v-icon size="48" color="grey lighten-2">mdi-file-document-outline</v-icon>
          <p class="mt-2">Nenhum título em aberto.</p>
        </div>
      </div>

      <simplebar
        v-else
        data-simplebar
        :autoHide="false"
        class="lista-resultados-container"
        style="height: 100%;"
      >
        <v-list dense class="py-0">
          <template v-for="(item, index) in titulos">
            <v-list-item :key="item.IdFinanceiro || index" class="px-3 py-1">
              <v-list-item-content>
                
                <v-list-item-title class="text-body-2 font-weight-medium d-flex justify-space-between">
                  <span>
                    {{ item.tipo }}/{{ item.especie }} 
                    <span class="ml-1 grey--text text--darken-2">{{ item.documento }} - {{ item.parcela }}</span>
                  </span>
                  <v-icon v-if="isVencido(item.vencimento)" x-small color="red">mdi-alert-circle</v-icon>
                </v-list-item-title>
                
                <v-list-item-subtitle class="caption mt-1 d-flex justify-space-between align-center">
                  <span>Emis: {{ formatarData(item.emissao) }}</span>
                  <span :class="isVencido(item.vencimento) ? 'red--text font-weight-bold' : ''">
                    Venc: {{ formatarData(item.vencimento) }}
                  </span>
                  <span class="black--text font-weight-bold">{{ formatarMoeda(item.saldo) }}</span>
                </v-list-item-subtitle>
              
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < titulos.length - 1" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </simplebar>
    </div>
  </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import moment from 'moment';
import db from '@/plugins/dexie';

export default {
  name: 'FinanceiroView',

  components: {
    simplebar,
  },

  data() {
    return {
      loading: false,
      titulos: [],
      totalDivida: 0,
      nomeCliente: '',
      codigoCliente: null,
      limiteCredito: 0,
      idVendedorCliente: 0,
    };
  },

  computed: {
    saldoCredito() {
      return this.limiteCredito - this.totalDivida;
    }
  },

  mounted() {
    this.lerParametrosRota();
  },

  watch: {
    '$route.query': {
      handler() {
        this.lerParametrosRota();
      },
      deep: true
    }
  },

  methods: {

    lerParametrosRota() {
      const { clienteCodigo, clienteNome, clienteLimite, clienteIdVendedor } = this.$route.query;

      if (clienteCodigo) {
        this.codigoCliente = clienteCodigo;
        this.nomeCliente = clienteNome || 'Cliente';
        this.limiteCredito = parseFloat(clienteLimite) || 0;
        this.idVendedorCliente = clienteIdVendedor || 0;

        this.carregarFinanceiro(this.codigoCliente, this.idVendedorCliente);
      }
    },

    async carregarFinanceiro(idCliente) {
      this.loading = true;
      try {
        const idCli = parseInt(idCliente);
        let dados = await db.financeiro
          .where('idcliente')
          .equals(idCli)
          .filter(doc => {
            const saldo = parseFloat(doc.saldo) || 0;
            const temSaldo = saldo > 0;
            const naoEstaBaixado = !doc.datafinal;
            return temSaldo && naoEstaBaixado;
          })
          .toArray();

        this.titulos = dados || [];

        this.totalDivida = this.titulos.reduce((sum, t) => {
          return sum + (parseFloat(t.saldo) || 0);
        }, 0);

      } catch (error) {
        console.error("Erro ao carregar financeiro do Dexie:", error);
        this.titulos = [];
        this.totalDivida = 0;
      } finally {
        this.loading = false;
      }
    },

    isVencido(dataVencimento) {
      if (!dataVencimento) return false;
      const hoje = new Date();
      hoje.setHours(0,0,0,0);
      const venc = new Date(dataVencimento);
      return venc < hoje;
    },

    formatarMoeda(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },

    formatarData(dataStr) {
      if (!dataStr) return '-';
      return moment(dataStr).format('DD/MM/YYYY');
    }
  },
};
</script>

<style scoped>
.view-wrapper {
  background-color: #ffffff;
}
.lista-resultados-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
} 
</style>